import { render, staticRenderFns } from "./JobCompliance.vue?vue&type=template&id=4fc4b2b4&scoped=true"
import script from "./JobCompliance.vue?vue&type=script&lang=ts"
export * from "./JobCompliance.vue?vue&type=script&lang=ts"
import style0 from "./JobCompliance.vue?vue&type=style&index=0&id=4fc4b2b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc4b2b4",
  null
  
)

export default component.exports